import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CustomCursor } from "@/components/CustomCursor";
import { SmoothScroll } from "@/components/SmoothScroll";
import { ScrollToTop } from "@/components/ScrollToTop";
import { FloatingActions } from "@/components/FloatingActions";
import { OpeningPopup } from "@/components/OpeningPopup";
import HomePage from "@/pages/Home";
import CafePage from "@/pages/Cafe";
import BrockenstubePage from "@/pages/Brockenstube";
import DienstleistungenPage from "@/pages/Dienstleistungen";
import GeschichtePage from "@/pages/Geschichte";
import KontaktPage from "@/pages/Kontakt";
import LegalPage from "@/pages/Legal";
import EventsPage from "@/pages/Events";
import EventDetailPage from "@/pages/EventDetail";
import VerwaltungPage from "@/pages/Verwaltung";

const PublicLayout = ({ children }) => (
  <>
    <CustomCursor />
    <SmoothScroll />
    <ScrollToTop />
    <Header />
    <main>{children}</main>
    <Footer />
    <FloatingActions />
    <OpeningPopup />
  </>
);

const Shell = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/verwaltung");

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/verwaltung" element={<VerwaltungPage />} />
      </Routes>
    );
  }

  return (
    <PublicLayout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/cafe" element={<CafePage />} />
        <Route path="/brockenstube" element={<BrockenstubePage />} />
        <Route path="/dienstleistungen" element={<DienstleistungenPage />} />
        <Route path="/geschichte" element={<GeschichtePage />} />
        <Route path="/kontakt" element={<KontaktPage />} />
        <Route path="/neuigkeiten" element={<EventsPage />} />
        <Route path="/neuigkeiten/:id" element={<EventDetailPage />} />
        <Route path="/impressum" element={<LegalPage type="imprint" />} />
        <Route path="/datenschutz" element={<LegalPage type="privacy" />} />
      </Routes>
    </PublicLayout>
  );
};

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <BrowserRouter>
          <Shell />
          <Toaster position="bottom-center" toastOptions={{ style: { background: "#2B1B12", color: "#FDFBF7", border: "1px solid rgba(200,169,126,0.3)" } }} />
        </BrowserRouter>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
